import { ReactNode } from 'react';
import { Navigate } from "react-router-dom";
import { useAuthContext } from "./AuthContext";
import { AuthError } from '../../Pages/Error/AuthError';


export function PrivateRoute({ children }: { children: JSX.Element }) {
  const { agree, userData } = useAuthContext();

  return agree === false ? (
    <Navigate to="/login" />
  ) : userData?.userStatus === "ban" ? (
    <Navigate to="/" />
  ) : userData?.email.includes("@mnes.org") || userData?.email.includes("@kasumiclinic.jp") ? (
    children
  ) : (
    <AuthError /> 
  );
}

export function AdminRoute( { children }: {children: JSX.Element }) {
  const { userData } = useAuthContext();
  return userData?.userStatus === 'admin' ? children : <AuthError/>;
}

export function EditRoute( { children }: {children: JSX.Element }) {
  const { userData } = useAuthContext();
  return (userData?.userStatus === 'edit') || (userData?.userStatus ==='admin') ? children : <AuthError/>;
}
